import ViblastInteraction from '../ViblastInteraction';
import logger from '../../log';
import modifyViblastRequest from './modifyViblastRequest';
import { ViblastXhr } from './interfaces';

const log = logger.getLogger(__filename);

export const getViblastXhr = (items: unknown[]): ViblastXhr | null => {
  return items.length > 0 ? (items[0] as ViblastXhr) : null;
};

const attachViblastInterceptor = (interaction: ViblastInteraction): void => {
  const wrapper = interaction.tech.getTechApiFunction('viblast.xhrBeforeSend');
  wrapper.setFunction((...items: unknown[]): void => {
    const options = interaction.binder.getOptions();
    const evt = getViblastXhr(items);
    const shouldIntercept = interaction.binder.shouldIntercept();
    log.debug('Calling ksdk.xhrBeforeSend', {
      evt,
      options,
      shouldIntercept
    });
    if (!shouldIntercept || !options) {
      return;
    }
    if (!evt) {
      log.warn('Attempting to use xhrBeforeSend without an event');
      return;
    }
    modifyViblastRequest(options, evt);
  });
};
export default attachViblastInterceptor;
